/** Default stroke/fill color for geofence rendering when API returns no color. */
export const DEFAULT_GEOFENCE_COLOR = '#FF0000';

/**
 * Fill opacity for the geofence polygon. A small opacity keeps the map visible
 * beneath the geofence area while still showing the boundary region clearly.
 */
export const DEFAULT_GEOFENCE_FILL_OPACITY = 0.1;

/**
 * Line width for the geofence boundary. 2px is a good visual thickness for
 * map layers at moderate zoom levels without being too bold.
 */
export const DEFAULT_GEOFENCE_LINE_WIDTH = 2;

/** Default marker size in pixels used for the alert violation marker. */
export const ALERT_MARKER_SIZE = 24;

/**
 * Default zoom level for the initial marker-centered map view when the alert
 * does not contain a geofence bounding box.
 */
export const DEFAULT_MAP_MARKER_ZOOM = 8;

/**
 * Maximum zoom level to use when fitting bounds around a geofence and marker.
 * This prevents overly tight zoom on very small fence geometries.
 */
export const DEFAULT_MAP_FIT_MAX_ZOOM = 16;

/**
 * Padding around the bounds when fitting the map to the marker and geofence.
 * This keeps the drawn geofence clearly visible and not clipped against the edge.
 */
export const DEFAULT_MAP_FIT_PADDING = 40;
